import React, { useState } from "react";
import "../App.css";
import TickerChart from "../component/FullScreenChart/TickerChart/TickerChart";
import TotalReportAnalysis from "../component/FullScreenChart/TotalReportAnalysis/TotalReportAnalysis";
import LineChart from "../component/FullScreenChart/LineChart/LineChart";
import GroupBarChart from "../component/FullScreenChart/GroupBarChart/GroupBarChart";
import CompanyNameChart from "../component/FullScreenChart/CompanyNameChart/CompanyNameChart";
import SevenBarChart from "../component/FullScreenChart/SevenBarChart/SevenBarChart";
import StackedBarChart from "../component/FullScreenChart/StackedBarChart/StackedBarChart";
import HorizontalBarChart from "../component/FullScreenChart/HorizontalBarChart/HorizontalBarChart";
import WorldMapChart from "../component/FullScreenChart/WorldMapChart/WorldMapChart";
import GeographyChart from "../component/FullScreenChart/GeographyChart/GeographyChart";
import prevs from "../images/prevs.svg"
import next from "../images/next.svg"
import HeaderFull from "../component/HeaderFull";

const FullChartsPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const components = [
    <GroupBarChart />,
    <CompanyNameChart />,
    <SevenBarChart />,
    <StackedBarChart />,
    <HorizontalBarChart />,
    <LineChart />,
    <TickerChart />,
    <TotalReportAnalysis />,
    <WorldMapChart />,
    <GeographyChart />,
  ];

  const handleNext = () => {
    if (currentIndex < components.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <>
    <HeaderFull/>
    <div className="full-chart-container">
      <div className="full-arrow left" onClick={handlePrevious}>{<img src={prevs}/>}</div>
      <div className="full-chart-display">{components[currentIndex]}</div>
      <div className="full-arrow right" onClick={handleNext}>{<img src={next}/>}</div>
    </div>
    </>
  );
};

export default FullChartsPage